import { render, staticRenderFns } from "./ShowFormPage.vue?vue&type=template&id=76525376"
import script from "./ShowFormPage.vue?vue&type=script&lang=js"
export * from "./ShowFormPage.vue?vue&type=script&lang=js"
import style0 from "./ShowFormPage.vue?vue&type=style&index=0&id=76525376&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports